<template>
    <div class="text-sm xs:text-base text-black font-bold mb-2.5">
        應注意事項：
    </div>
    <ol class="text-sm xs:text-base list-decimal list-inside">
        <li class="indent-1 mb-1 md:mb-2">
            單張保險契約單次借款之金額限制約當新台幣1,000元~100萬元。
        </li>
        <li class="indent-1  mb-1 md:mb-2">
            辦理保單借款時，若該保單尚有未清償之借款本息者，本次欲借款金額加已借款本息合計須於該保單最高可借款金額範圍內，若借款給付當時之已借款本息與申請當時不同，本公司將依該保單最高可借款金額範圍內調整本次借款金額。
        </li>
        <li class="indent-1  mb-1 md:mb-2">
            本公司不定期推出保單借款優惠專案，若您辦理保單借款當時符合專案條件，即可享有優惠，保單借款優惠專案詳情請查詢本公司官方網站www.fubon.com，或保單借還款服務專線0809-026-688。
        </li>
        <li class="indent-1  mb-1 md:mb-2">
            保單已為繳清件、展期件、自動墊繳件、以支票還款且尚未兌現者或要/被保險人非同一人時，請洽本公司各地服務櫃檯，或由您的保單服務人員協助以書面方式辦理。
        </li>
        <li class="indent-1 mb-1 md:mb-2">
            為保障保戶權益，於<span class="text-error">審理必要時</span>會以電話方式與要保人、法定代理人聯繫以完成審核確認。
            <ul class="text-error">
                <li class="indent-1.75">
                    5.1 請確認您於本公司登錄之保單聯絡電話為有效，並請保持話機暢通，以避免影響匯款時效。
                </li>
                <li class="indent-1.75">
                    5.2 若您原登錄之聯絡電話已異動，請洽本公司各地服務櫃檯，或透過您的保單服務人員辦理更新。
                </li>
                <li class="indent-1.75">
                    5.3 本公司將持續聯繫三個營業日，若仍無法聯繫，則將取消該次保單借款。
                </li>
            </ul>
        </li>
        <li class="indent-1  mb-1 md:mb-2">
            配合您的申請及銀行資料交換時間，預計匯款日說明如下：
            <ul>
                <li class="indent-1.75">
                    <span>6.1 如本次申請符合快速匯款服務，交易委託完成後，將提示您預計於1個小時內可匯入您的帳戶，惟仍可能因以下情形而有調整：</span>
                    <ul class="list-disc list-inside">
                        <li class="indent-1.5">
                            您的帳戶資訊有誤或因戶名難字或其他原因致銀行無法接收。
                        </li>
                        <li class="indent-1.5">
                            申請交易時間已逾當日匯款時間，則於次一營業日匯款。
                        </li>
                    </ul>
                </li>
                <li class="indent-1.75">
                    <span>6.2 如本次申請未符合快速匯款服務，交易委託完成後，將提示您預計匯款日期，惟仍可能因說明５之電訪未完成影響匯款日期：</span>
                    <ul class="list-disc list-inside">
                        <li class="indent-1.5">
                            營業日14:00(含)前委託交易完成且無需以電話確認：將於當日匯款；需以電話確認者，則於次一營業日匯款。
                        </li>
                        <li class="indent-1.5">
                            營業日14:01後或例假日委託交易完成：將於次一營業日匯款。
                        </li>
                    </ul>
                </li>
            </ul>
        </li>
        <li class="indent-1">
            您的保險單、存摺、印章、網路交易帳號密碼應親自保管，請勿交予他人，本公司嚴禁業務同仁代保管客戶保險單、存摺、印章、網路交易帳號密碼等資料。
        </li>
    </ol>
</template>

<script>
export default {
    setup() {
        return {
        };
    }
};
</script>
